import { Injectable, Provider } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AvailabilityNotificationClient, AvailabilityNotificationCreateCommand, AvailabilityNotificationCreateCommandResult,
  AvailabilityNotificationDeleteCommand, AvailabilityNotificationDeleteCommandResult, ProductIdentifierDto
} from '../../INTEGRA_Shop_Client';
import { IAvailabilityNotificationApiService, IAvailabilityNotificationApiServiceToken } from './availability-notification-api-service.interface';

@Injectable({
  providedIn: 'root'
})
export class AvailabilityNotificationApiService implements IAvailabilityNotificationApiService {

  constructor(
    private availabilityNotificationClient: AvailabilityNotificationClient
  ) { }

  public availabilityNotificationCreate(productList: ProductIdentifierDto[]): Observable<AvailabilityNotificationCreateCommandResult> {
    let query = new AvailabilityNotificationCreateCommand();
    query.productList = productList;

    return this.availabilityNotificationClient.availabilityNotificationCreate(query);
  }

  public availabilityNotificationDelete(productList: ProductIdentifierDto[]): Observable<AvailabilityNotificationDeleteCommandResult> {
    let command = new AvailabilityNotificationDeleteCommand();
    command.productList = productList;

    return this.availabilityNotificationClient.availabilityNotificationDelete(command);
  }
}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const AvailabilityNotificationApiServiceProvider: Provider[] = [
  { provide: AvailabilityNotificationClient },
  { provide: IAvailabilityNotificationApiServiceToken, useExisting: AvailabilityNotificationApiService }
];
